var _path, _path2, _circle, _path3, _path4, _path5, _path6, _path7, _path8, _g, _circle2, _path9, _path0, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDisconnect({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 201,
    height: 200,
    viewBox: "0 0 201 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M192.659 98.8767C192.659 148.272 152.616 188.315 103.221 188.315C53.8253 188.315 13.7825 148.272 13.7825 98.8767C13.7825 49.4813 53.8253 9.43848 103.221 9.43848C152.616 9.43848 192.659 49.4813 192.659 98.8767Z",
    fill: "url(#paint0_linear_298_12106)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M181.601 70.9308C183.564 70.9308 185.156 69.339 185.156 67.3755C185.156 65.412 183.564 63.8202 181.601 63.8202C179.637 63.8202 178.046 65.412 178.046 67.3755C178.046 69.339 179.637 70.9308 181.601 70.9308ZM181.601 72.7285C184.557 72.7285 186.954 70.3319 186.954 67.3755C186.954 64.4191 184.557 62.0225 181.601 62.0225C178.644 62.0225 176.248 64.4191 176.248 67.3755C176.248 70.3319 178.644 72.7285 181.601 72.7285Z",
    fill: "url(#paint1_linear_298_12106)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 103.399,
    cy: 173.444,
    r: 5.35304,
    fill: "url(#paint2_linear_298_12106)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M66.2979 18.6612C66.4674 18.2468 67.0541 18.2468 67.2236 18.6612L70.064 25.6079C70.0811 25.6498 70.1038 25.6891 70.1315 25.7249L74.7273 31.6581C75.0015 32.012 74.7081 32.5202 74.2645 32.4597L66.8283 31.4462C66.7835 31.4401 66.738 31.4401 66.6932 31.4462L59.257 32.4597C58.8134 32.5202 58.52 32.012 58.7941 31.6581L63.39 25.7249C63.4177 25.6891 63.4404 25.6498 63.4575 25.6079L66.2979 18.6612Z",
    fill: "url(#paint3_linear_298_12106)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9741 96.7093C23.9513 96.9712 24.2786 98.1927 23.5633 98.9081L18.5257 103.946C17.8103 104.661 16.5888 104.334 16.327 103.356L14.4831 96.475C14.2213 95.4978 15.1155 94.6036 16.0927 94.8655L22.9741 96.7093Z",
    fill: "url(#paint4_linear_298_12106)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M176.052 90.3056C174.635 82.1024 166.229 75.7222 152.658 72.3802C151.848 72.1776 151.038 72.2789 150.43 72.684C149.114 70.6585 147.696 68.7343 146.177 67.0127C135.847 54.8599 120.555 47.1631 103.439 47.1631C72.4498 47.1631 47.334 72.2789 47.334 103.269C47.334 108.636 48.1442 113.902 49.562 118.865C52.0938 120.08 55.4358 121.194 59.7906 122.105C72.4498 124.739 89.6663 124.536 106.781 121.396C134.733 116.333 152.253 106.408 159.545 99.2176C159.14 95.268 158.431 91.5208 157.317 87.7737C156.405 84.7355 155.291 81.7986 153.975 78.9629C163.393 81.6973 169.267 86.2546 170.179 91.3183C170.685 94.1539 169.774 97.1922 167.546 100.433C159.342 112.181 135.341 123.422 107.895 128.384C67.9938 135.473 38.827 127.372 36.599 115.219C36.1939 112.991 36.599 110.763 37.8143 108.434C38.5232 107.016 38.0168 105.193 36.4977 104.383C35.0799 103.674 33.257 104.18 32.4468 105.699C30.6239 109.244 30.0162 112.788 30.6239 116.333C32.2442 125.245 41.6627 131.828 57.0562 134.967C63.8415 136.385 71.437 137.094 79.6402 137.094C88.9573 137.094 98.8821 136.182 108.807 134.461C138.277 129.195 163.191 117.244 172.407 103.977C175.647 99.3189 176.863 94.7616 176.052 90.3056ZM79.6402 144.284C74.1714 144.284 69.0065 143.98 64.0441 143.373C74.1714 153.298 88.0459 159.475 103.439 159.475C125.922 159.475 145.367 146.208 154.279 127.068C141.62 133.549 126.125 138.512 110.225 141.347C99.7936 143.272 89.3624 144.284 79.6402 144.284Z",
    fill: "url(#paint5_linear_298_12106)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M62.6042 58.2995C62.7653 57.8642 63.381 57.8642 63.542 58.2995L64.6061 61.1751C64.6568 61.312 64.7647 61.4199 64.9015 61.4705L67.7772 62.5346C68.2125 62.6957 68.2125 63.3114 67.7772 63.4725L64.9015 64.5365C64.7647 64.5872 64.6568 64.6951 64.6061 64.832L63.542 67.7076C63.381 68.1429 62.7653 68.1429 62.6042 67.7076L61.5401 64.832C61.4895 64.6951 61.3816 64.5872 61.2447 64.5365L58.3691 63.4725C57.9338 63.3114 57.9338 62.6957 58.3691 62.5346L61.2447 61.4705C61.3816 61.4199 61.4895 61.312 61.5401 61.1751L62.6042 58.2995Z",
    fill: "url(#paint6_linear_298_12106)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.2323 151.254C39.7458 151.254 40.9727 150.027 40.9727 148.513C40.9727 147 39.7458 145.773 38.2323 145.773C36.7188 145.773 35.4918 147 35.4918 148.513C35.4918 150.027 36.7188 151.254 38.2323 151.254ZM38.2323 153.051C40.7387 153.051 42.7705 151.02 42.7705 148.513C42.7705 146.007 40.7387 143.975 38.2323 143.975C35.7259 143.975 33.6941 146.007 33.6941 148.513C33.6941 151.02 35.7259 153.051 38.2323 153.051Z",
    fill: "url(#paint7_linear_298_12106)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M167.5 152.278C167.661 151.843 168.277 151.843 168.438 152.278L170.144 156.89C170.195 157.027 170.303 157.135 170.44 157.186L175.052 158.893C175.487 159.054 175.487 159.669 175.052 159.83L170.44 161.537C170.303 161.588 170.195 161.696 170.144 161.833L168.438 166.445C168.277 166.88 167.661 166.88 167.5 166.445L165.793 161.833C165.742 161.696 165.634 161.588 165.498 161.537L160.885 159.83C160.45 159.669 160.45 159.054 160.885 158.893L165.498 157.186C165.634 157.135 165.742 157.027 165.793 156.89L167.5 152.278Z",
    fill: "url(#paint8_linear_298_12106)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_298_12106)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 133.154,
    cy: 64.599,
    r: 17.1297,
    fill: "var(--color-error)"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 133.154,
    cy: 61.1727,
    r: 17.1297,
    fill: "var(--color-error)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M133.22 63.7613L132.613 56.0759L132.501 52.7276H136.231L136.119 56.0759L135.512 63.7613H133.22ZM134.366 69.7389C133.796 69.7389 133.325 69.5516 132.95 69.1771C132.575 68.8025 132.388 68.3306 132.388 67.7613C132.388 67.1771 132.575 66.6977 132.95 66.3231C133.325 65.9486 133.796 65.7613 134.366 65.7613C134.935 65.7613 135.407 65.9486 135.781 66.3231C136.156 66.6977 136.343 67.1771 136.343 67.7613C136.343 68.3306 136.156 68.8025 135.781 69.1771C135.407 69.5516 134.935 69.7389 134.366 69.7389Z",
    fill: "var(--color-bg-base)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M163.888 127.19C165.253 127.19 166.359 126.083 166.359 124.718C166.359 123.353 165.253 122.246 163.888 122.246C162.522 122.246 161.416 123.353 161.416 124.718C161.416 126.083 162.522 127.19 163.888 127.19ZM163.888 128.988C166.246 128.988 168.157 127.076 168.157 124.718C168.157 122.36 166.246 120.448 163.888 120.448C161.53 120.448 159.618 122.36 159.618 124.718C159.618 127.076 161.53 128.988 163.888 128.988Z",
    fill: "url(#paint9_linear_298_12106)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_298_12106",
    x: 102.541,
    y: 33.9861,
    width: 61.2258,
    height: 61.2256,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.74157,
    result: "effect1_foregroundBlur_298_12106"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_298_12106",
    x1: 102.531,
    y1: -19.6848,
    x2: 104.363,
    y2: 294.409,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "var(--color-bg-base)",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "var(--color-brand-400)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_298_12106",
    x1: 176.236,
    y1: 64.4933,
    x2: 187.012,
    y2: 64.5632,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "var(--color-brand-400)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "var(--color-brand-550)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_298_12106",
    x1: 98.0338,
    y1: 170.562,
    x2: 108.81,
    y2: 170.632,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "var(--color-brand-400)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "var(--color-brand-550)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_298_12106",
    x1: 56.6742,
    y1: 22.1744,
    x2: 76.9339,
    y2: 22.306,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "var(--color-brand-400)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "var(--color-brand-550)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_298_12106",
    x1: 20.4183,
    y1: 91.5772,
    x2: 23.8458,
    y2: 104.709,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "var(--color-brand-400)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "var(--color-brand-550)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_298_12106",
    x1: 143.876,
    y1: 47.3283,
    x2: 142.926,
    y2: 159.859,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "var(--color-brand-400)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "var(--color-brand-550)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_298_12106",
    x1: 57.0883,
    y1: 59.7884,
    x2: 69.1094,
    y2: 59.8665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "var(--color-brand-400)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "var(--color-brand-550)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_298_12106",
    x1: 33.6838,
    y1: 146.07,
    x2: 42.8198,
    y2: 146.129,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "var(--color-brand-400)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "var(--color-brand-550)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_298_12106",
    x1: 159.599,
    y1: 154.865,
    x2: 176.41,
    y2: 154.974,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "var(--color-brand-400)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "var(--color-brand-550)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_298_12106",
    x1: 159.608,
    y1: 122.419,
    x2: 168.204,
    y2: 122.475,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "var(--color-brand-400)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "var(--color-brand-550)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisconnect);
export default __webpack_public_path__ + "static/media/disconnect.1649f50d57370e826b57d25d237e17cf.svg";
export { ForwardRef as ReactComponent };